import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators } from '@angular/forms';
import { UserCustomerFormInterface } from '../_interfaces/base-user-management.interface';
import { baseAdministrationSelectors, baseAdministrationActions, BaseCoreState } from '../../../_store';
import { filter, map } from 'rxjs/operators';
import { BaseNameIdInterface } from '../../../shared/interfaces/base-name-id.interface';
import { Store } from '@ngrx/store';

@Injectable()
export class BaseUserManagementService {
  constructor(private store: Store<BaseCoreState>) {}

  removeOptionalFormControls(customerForm: FormGroup<UserCustomerFormInterface>) {
    this.removeControls(customerForm, ['group', 'customerDepartments', 'customerLocations']);
  }

  addControls<T extends { [K in keyof T]: AbstractControl<any, any> }>(
    form: FormGroup<T>,
    controlNames: Extract<keyof T, string>[]
  ) {
    controlNames.forEach((controlName) => {
      if (!form.contains(controlName)) {
        (form as FormGroup).addControl(
          controlName,
          new FormControl(null as any, { nonNullable: true, validators: [Validators.required] })
        );
      }
    });
  }

  removeControls<T extends { [K in keyof T]: AbstractControl<any, any> }>(
    form: FormGroup<T>,
    controlNames: Extract<keyof T, string>[]
  ): void {
    controlNames.forEach((controlName) => {
      if (form.contains(controlName)) {
        (form as FormGroup).removeControl(controlName);
      }
    });
  }

  getCustomerLocations() {
    this.store.dispatch(baseAdministrationActions.loadLocations({ payload: { isActive: true } }));

    return this.store.select(baseAdministrationSelectors.getLocations).pipe(
      filter((value) => !!value.ok),
      map((value) => (value.data || []).map((loc) => ({ name: loc.name, id: loc.id })) as BaseNameIdInterface[])
    );
  }
}
